import { EntityType } from '@shared/models/entity-enum';
import { TOTAL_ENTITIES } from '@shared/services/app-storage.service';

/**
 * Checks if Entity is Checked in the current user catalog
 */
export function isEntityActive(targetEntity: EntityType): boolean {
  const totalEntities = JSON.parse(localStorage.getItem(TOTAL_ENTITIES));
  const _isEntityChecked = ({ entityObj }) => entityObj.name.toLowerCase() === targetEntity && entityObj.isChecked;
  return totalEntities?.some(_isEntityChecked);
}

export const isTenancyActive = () => isEntityActive(EntityType.Tenancy);

export const isSaleCompActive = () => isEntityActive(EntityType.SaleComp);

export const isTIMActive = () => isEntityActive(EntityType.Tim);
